<div class="irembogov-bulk-progress-tracker">
  <!-- Loading State -->
  <div
    *ngIf="(isLoading && !currentProgress) || isWaitingForProcessing"
    class="text-center py-4">
    <span
      class="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"></span>
    <span>{{ 'BULK_PROGRESS.LOADING' | translate }}</span>
  </div>

  <!-- Progress Info Box -->
  <div
    *ngIf="currentProgress && !isWaitingForProcessing"
    class="progress-info-box">
    <div class="info-icon">
      <img
        src="assets/images/file-04.svg"
        alt="file icon"
        width="18"
        height="18" />
    </div>
    <div class="info-content">
      <p class="info-message">
        {{ mergedLabels.processingMessage | translate }}
      </p>

      <div class="progress-stats">
        <div class="stat-item">
          <span class="stat-label"
            >{{ mergedLabels.invalidLabel | translate }}:</span
          >
          <span class="stat-value">
            {{ currentProgress.totalFailedChildApplications }}
          </span>
        </div>
        <div class="stat-item">
          <span class="stat-label"
            >{{ mergedLabels.validLabel | translate }}:</span
          >
          <span class="stat-value">{{
            currentProgress.totalSuccessfulChildApplications
          }}</span>
        </div>
      </div>

      <!-- Progress Bar and Text Container -->
      <div class="progress-container">
        <div class="progress-bar-container">
          <div
            class="progress-bar-fill"
            [style.width.%]="currentProgress.percentageComplete"></div>
        </div>
        <div class="progress-text">
          {{
            currentProgress.totalSuccessfulChildApplications +
              currentProgress.totalFailedChildApplications
          }}
          /{{ currentProgress.totalExpectedChildApplications }}
          {{ mergedLabels.itemsChecked | translate }}
          <span
            *ngIf="isWaitingForBillId"
            class="spinner-border spinner-border-sm ms-2"
            role="status"
            aria-hidden="true"></span>
        </div>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="hasError" class="alert alert-danger mt-3" role="alert">
    <i class="fa fa-exclamation-circle me-2"></i>
    {{ errorMessage }}
  </div>

  <!-- Failed Applications Section -->
  <div
    *ngIf="hasFailedApplications && currentProgress && isProcessingComplete"
    class="failed-section mt-4">
    <div class="failed-header">
      <div class="failed-title">
        <img
          src="assets/images/alert-triangle.svg"
          alt="alert icon"
          width="20"
          height="20"
          class="me-2" />
        <span class="fw-semibold">{{
          mergedLabels.invalidLabel | translate
        }}</span>
        <span class="badge badge-danger ms-2">{{
          currentProgress.totalFailedChildApplications
        }}</span>
      </div>

      <button
        *ngIf="failedApplications.length > 0"
        type="button"
        class="btn btn-outline-primary btn-sm"
        (click)="downloadFailedReport()"
        [disabled]="isLoadingFailedApps">
        <i class="fa fa-download me-1"></i>
        {{ mergedLabels.downloadReport | translate }}
      </button>
    </div>

    <!-- Failed Applications Table -->
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>{{ mergedLabels.identifierHeader | translate }}</th>
            <th>{{ mergedLabels.errorMessageHeader | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- Data Rows -->
          <tr *ngFor="let app of failedApplications">
            <td class="fw-light">{{ app.displayIdentifier }}</td>
            <td class="text-muted">
              {{
                app.errorCode
                  ? (app.errorCode | translate : app.errorMetadata)
                  : (app.errorMessage ?? 'BULK_PROGRESS.NO_ERROR_MESSAGE'
                    | translate : app.errorMetadata)
              }}
            </td>
          </tr>

          <!-- Loading Shimmer -->
          <ng-container *ngIf="isLoadingFailedApps">
            <tr *ngFor="let item of [1, 2, 3]">
              <td>
                <div class="line loading-shimmer"></div>
              </td>
              <td>
                <div class="line loading-shimmer"></div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
